import { applyMiddleware, createStore, compose } from 'redux';
import thunk from 'redux-thunk';
import reducer from 'reducer';
import { createRandomState } from 'data/createRandomState';

const configureStore = () => {
  let initialState = {};
  if (process.env.NODE_ENV === 'development') {
    initialState = createRandomState(0, 0, 0);
  } else {
    initialState = createRandomState(0, 0, 0);
  }
  console.log(initialState);

  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const store = createStore(
    reducer,
    initialState,
    composeEnhancers(applyMiddleware(thunk))
  );

  if (process.env.NODE_ENV !== 'production') {
    if (module.hot) {
      module.hot.accept('./reducer', () => {
        const nextReducer = require('./reducer').default; // eslint-disable-line global-require
        store.replaceReducer(nextReducer);
      });
    }
  }

  return store;
};

export default configureStore;
